import React from "react";
import { Collapse } from "antd";
import { DownOutlined } from "@ant-design/icons";

import "./style.scss";

function CustomCollapse({ defaultActiveKey = [""], items = [] }) {
  return (
    <div className="agent-mobile-custom-collapse">
      <Collapse
        defaultActiveKey={defaultActiveKey}
        ghost
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <DownOutlined
            rotate={isActive ? 180 : 0}
            style={{ fontSize: "16px" }}
          />
        )}
      >
        {items?.map((item, index) => {
          return (
            <Collapse.Panel key={"collapse" + index} header={item.title}>
              <div
                className={"content"}
                dangerouslySetInnerHTML={{ __html: item.content }}
              ></div>
            </Collapse.Panel>
          );
        })}
      </Collapse>
    </div>
  );
}

export default CustomCollapse;
